import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Fuel, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm animate-fadeUp" data-testid="reset-form">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-lg bg-emerald-500 flex items-center justify-center">
            <Fuel className="w-6 h-6 text-black" />
          </div>
          <span className="font-[Outfit] font-bold text-2xl text-white">Fuel Tracer</span>
        </div>
        <h2 className="font-[Outfit] font-bold text-2xl text-white mb-1">Set a new password</h2>
        <p className="text-[#9CA3AF] text-sm mb-6">Choose a strong password for your account.</p>
        {!token && <div className="mb-4 text-sm text-red-400">Missing reset token. Use the link from your email.</div>}
        {error && <div className="mb-4 text-sm text-red-400">{error}</div>}
        <Label htmlFor="password" className="text-[#9CA3AF]">New password</Label>
        <Input
          id="password" type="password" data-testid="reset-password-input" value={password}
          onChange={(e) => setPassword(e.target.value)} required minLength={6}
          className="mt-1.5 bg-[#111827] border-[#374151] text-white"
        />
        <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button"
          className="w-full mt-6 bg-emerald-500 hover:bg-emerald-400 text-black font-semibold">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
        </Button>
        <Link to="/login" className="block mt-4 text-center text-emerald-400 text-sm hover:underline">← Back to sign in</Link>
      </form>
    </div>
  );
}
